import { localStorageGet, localStorageSet, localStorageRemove } from 'Utils/Storage';
import { SET_BANGO, CLEAR_BANGO, SET_INITIAL_SHEER_STEP, SET_REDIRECT_URL } from '../Types';

// action creators
export const setBango = (payload) => ({ type: SET_BANGO, payload });
export const resetBango = () => ({ type: CLEAR_BANGO });
export const setInitialStep = () => ({ type: SET_INITIAL_SHEER_STEP });
export const setRedirectUrl = (payload) => ({ type: SET_REDIRECT_URL, payload });

// action thunks
export const checkBangoParams = () => (dispatch) => {
  const windowUrl = window?.location?.search?.replace('\\u0026', '&');
  const query = new URLSearchParams(windowUrl);
  const subscriptionId = query.get('subscriptionRequestId') || localStorageGet('subscriptionRequestId') || '';
  const redirectUrl = query.get('redirect_uri') || localStorageGet('redirect_uri') || '';
  const productId = query.get('productId') || localStorageGet('productId') || '';

  if (subscriptionId) {
    localStorageSet('subscriptionRequestId', subscriptionId);
    localStorageSet('redirect_uri', redirectUrl);
    localStorageSet('productId', productId);
    return dispatch(setBango({ subscriptionId, redirectUrl, productId }));
  }
};

export const clearBango = () => (dispatch) => {
  localStorageRemove('subscriptionRequestId');
  localStorageRemove('redirect_uri');
  localStorageRemove('productId');
  dispatch(resetBango());
};

export const addRedirectUrl = (redirectUrl) => (dispatch) => {
  localStorageSet('redirect_uri', redirectUrl);
  return dispatch(setRedirectUrl(redirectUrl));
};
